import React from 'react';
import { BrochureHero } from '../components/BrochureHero';
import { ServicesSection } from '../components/ServicesSection';
import { WhyChooseSection } from '../components/WhyChooseSection';
import { ImpactSection } from '../components/ImpactSection';
import { ContactSection } from '../components/ContactSection';
export function Brochure() {
  return <div className="min-h-screen bg-white" data-id="element-148">
      {/* Print Header - Only visible in print */}
      <div className="hidden print:block text-center py-4 border-b border-slate-200" data-id="element-149">
        <div className="font-serif font-bold text-xl text-navy" data-id="element-150">
          London Bridge Academic Services
        </div>
        <div className="text-sm text-gold" data-id="element-151">TVET Excellence Programme</div>
      </div>

      <main data-id="element-152">
        <BrochureHero data-id="element-153" />
        <ServicesSection data-id="element-154" />
        <div className="page-break" data-id="element-155"></div>
        <WhyChooseSection data-id="element-156" />
        <ImpactSection data-id="element-157" />
        <div className="page-break" data-id="element-158"></div>
        <ContactSection data-id="element-159" />
      </main>

      {/* Print Footer - Only visible in print */}
      <div className="hidden print:block text-center py-4 border-t border-slate-200 text-xs text-slate-500" data-id="element-160">
        <p data-id="element-161">
          © {new Date().getFullYear()} London Bridge Academic Services |
          Building Your Bridge to TVET Excellence
        </p>
      </div>
    </div>;
}